.absoluteLeft0 {
  position: absolute;
  left: 0;
}

.absoluteTopRight {
  position: absolute;
  top: 0;
  right: -2px;
}

.aibBlock {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.aibLine {
  min-height: 24px;
  display: inline-flex;
  width: 100%;
}

.aibLine:hover .aibLineButtons {
  opacity: 1;
}

.aibLine:last-child .aibLineItem {
  border-bottom: 1px dashed grey;
}

.aibLineButtons {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-left: 0.25rem;
  max-width: 52px;
  min-width: 52px;
  opacity: 0.2;
  position: relative;
  right: 0;
  transition: opacity 0.3s ease-in-out;
  width: 52px;
}

.aibLineItem {
  border-top: 1px dashed grey;
  border-left: 1px dashed grey;
}

.aibLineItem:last-child {
  border-right: 1px dashed grey;
}

.aibLineItem.one {
  width: 100%;
}

.aibLineItem.three {
  width: 33.3333%;
}

.aibLineItem.two {
  width: 50%;
}

.aibLineItemHolder {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.aibReadOnly {
  background-color: #d3d3d329;
  color: #0d0d0dc7;
  font-style: italic;
  opacity: 1;
}

.aioBodyRow {
  display: table-row;
}

.aioButtonHolder {
  position: relative;
  display: inline-flex;
}

.aioButtonHolder:not(:first-child) {
  margin-left: 2px;
}

.aioCommentHolder {
  display: table-cell;
}

.aioDropItem {
  background-color: rgb(214, 139, 25);
  color: rgb(240, 255, 250);
  padding: 2px 6px;
  box-shadow: 3px 3px 3px rgb(64, 64, 64, 0.5);
}

.aioDropItem:first-child {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.aioDropItem:hover {
  background-color: orangered;
}

.aioDropItem:last-child {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding-bottom: 6px;
}

.aioDropItemsHolder {
  position: absolute;
  z-index: 501;
  left: 1.25rem;
}

.aioDropItemsInnerHolder {
  position: relative;
}

.aioInput {
  min-width: 171px;
  border: 1px solid black;
  border-radius: 3px;
}

.aioInputHolder {
  display: table-cell;
}

.aioInputHolder input:not(:first-child),
.aioInputHolder textarea:not(:first-child) {
  margin-top: 2px;
}

.aioLabel {
  min-width: 125px;
  padding-left: 1rem;
  padding-right: 0.5rem;
  display: table-cell;
}

.aiordMain textarea {
  resize: both;
}

.aiordvMain {
  display: flex;
  flex-direction: row;
}

.aioRoValue {
  display: table-cell;
}

.aioSelect {
  border: 1px solid black;
  min-width: 177px;
}

.aioTip {
  position: relative;
}

.aioTip .aioTiptext {
  visibility: hidden;
  position: absolute;
  width: 121px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.6s;
}

.aioTip .aioTiptext2 {
  visibility: hidden;
  position: absolute;
  width: max-content;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  z-index: 1;
}

.aioTip .aioTiptextBottomarrow {
  visibility: hidden;
  width: 120px;
  background-color: #111;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 130%;
  left: 50%;
  margin-left: -60px;
}

.aioTip .aioTiptextBottomarrow::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.aioTip .aioTiptextLeftarrow {
  visibility: hidden;
  width: 120px;
  background-color: #111;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 110%;
}

.aioTip .aioTiptextLeftarrow::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent black transparent transparent;
}

.aioTip .aioTiptextRightarrow {
  visibility: hidden;
  width: 120px;
  background-color: #111;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: -5px;
  right: 110%;
}

.aioTip .aioTiptextRightarrow::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent black;
}

.aioTip .aioTiptextToparrow {
  visibility: hidden;
  width: 120px;
  background-color: #111;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 150%;
  left: 50%;
  margin-left: -60px;
}

.aioTip .aioTiptextToparrow::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

.aioTip:hover .aioTiptext {
  visibility: visible;
  opacity: 1;
}

.aioTip:hover .aioTiptext2 {
  visibility: visible;
}

.aioTip:hover .aioTiptextBottomarrow {
  visibility: visible;
}

.aioTip:hover .aioTiptextLeftarrow {
  visibility: visible;
}

.aioTip:hover .aioTiptextRightarrow {
  visibility: visible;
}

.aioTip:hover .aioTiptextToparrow {
  visibility: visible;
}

.aioTipBottom {
  top: 135%;
  left: 50%;
  margin-left: -60px;
}

.aioTipBottom::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #555 transparent;
}

.aioTipBottom2 {
  top: 125%;
  left: 50%;
  margin-left: -60px;
}

.aioTipLeft {
  top: -5px;
  bottom: auto;
  right: 128%;
}

.aioTipLeft::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent #555;
}

.aioTipLeft2 {
  top: -5px;
  bottom: auto;
  right: 105%;
}

.aioTipLhs {
  position: absolute;
  left: 0;
}

.aioTipRhs {
  position: absolute;
  right: 0;
}

.aioTipRight {
  top: -5px;
  left: 125%;
}

.aioTipRight::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #555 transparent transparent;
}

.aioTipRight2 {
  top: -5px;
  left: 105%;
}

.aioTipTop {
  bottom: 150%;
  margin-left: -57px;
}

.aioTipTop::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.aioTipTop2 {
  bottom: 150%;
  margin-left: -57px;
}

.aioUpdateButton {
  margin-top: 0.5rem;
}

.aioValue {
  display: table-cell;
}

.aiox {
  padding: 0;
  display: inline-flex;
  align-items: flex-start;
}

.aiox.closed > .aioxButton.aioxOpenClose {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-caret-down-square' viewBox='0 0 16 16'%3E%3Cpath d='M3.626 6.832A.5.5 0 0 1 4 6h8a.5.5 0 0 1 .374.832l-4 4.5a.5.5 0 0 1-.748 0l-4-4.5z'/%3E%3Cpath d='M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2z'/%3E%3C/svg%3E");
  margin-right: 0.25rem;
}

.aiox.open > .aioxButton.aioxOpenClose {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-caret-up-square' viewBox='0 0 16 16'%3E%3Cpath d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z'/%3E%3Cpath d='M3.544 10.705A.5.5 0 0 0 4 11h8a.5.5 0 0 0 .374-.832l-4-4.5a.5.5 0 0 0-.748 0l-4 4.5a.5.5 0 0 0-.082.537z'/%3E%3C/svg%3E");
}

.aiox.open > .aioxLabel {
  min-width: 80px;
  padding-left: 0.75rem;
}

.aioxButton {
  min-width: 16px;
  width: 16px;
  height: 16px;
  margin: 0;
  border: 0;
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
  display: inline-block;
}

.aioxButton.aioxAddDown {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-arrow-down-square' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxCircle {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxCircleRed {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='crimson' d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxDown {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-caret-down' viewBox='0 0 16 16'%3E%3Cpath d='M3.204 5h9.592L8 10.481 3.204 5zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxExplode {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-arrow-right-square' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4.5 5.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxGrip {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='8' fill='currentColor' class='bi bi-grip-horizontal' viewBox='0 0 16 16'%3E%3Cpath d='M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxImplode {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='crimson' class='bi bi-arrow-left-square' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm11.5 5.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxList {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-list' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxMinus {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='crimson' class='bi bi-dash-circle' viewBox='0 0 16 16'%3E%3Cpath d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/%3E%3Cpath d='M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxPlus {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-plus-circle' viewBox='0 0 16 16'%3E%3Cpath d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/%3E%3Cpath d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxRemoveUp {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='crimson' class='bi bi-arrow-up-square' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButton.aioxUp {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-caret-up' viewBox='0 0 16 16'%3E%3Cpath d='M3.204 11h9.592L8 5.519 3.204 11zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aioxButtonCell {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-box-arrow-in-down-left' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M9.636 2.5a.5.5 0 0 0-.5-.5H2.5A1.5 1.5 0 0 0 1 3.5v10A1.5 1.5 0 0 0 2.5 15h10a1.5 1.5 0 0 0 1.5-1.5V6.864a.5.5 0 0 0-1 0V13.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z'/%3E%3Cpath fill-rule='evenodd' d='M5 10.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1H6.707l8.147-8.146a.5.5 0 0 0-.708-.708L6 9.293V5.5a.5.5 0 0 0-1 0v5z'/%3E%3C/svg%3E");
}

.aioxButtonHolder {
  height: 16px;
  display: table-cell;
}

.aioxButtonRowGroup {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-box-arrow-down-right' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8.636 12.5a.5.5 0 0 1-.5.5H1.5A1.5 1.5 0 0 1 0 11.5v-10A1.5 1.5 0 0 1 1.5 0h10A1.5 1.5 0 0 1 13 1.5v6.636a.5.5 0 0 1-1 0V1.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6.636a.5.5 0 0 1 .5.5z'/%3E%3Cpath fill-rule='evenodd' d='M16 15.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h3.793L6.146 6.854a.5.5 0 1 1 .708-.708L15 14.293V10.5a.5.5 0 0 1 1 0v5z'/%3E%3C/svg%3E");
}

.aioxButtonRowOptions {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-box-arrow-left' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z'/%3E%3Cpath fill-rule='evenodd' d='M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z'/%3E%3C/svg%3E");
}

.aioxButtonSettings {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-gear' viewBox='0 0 16 16'%3E%3Cpath d='M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z'/%3E%3Cpath d='M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z'/%3E%3C/svg%3E");
}

.aioxTable {
  padding: 0;
  margin: 0;
  display: table;
  width: 100%;
}

.aioxTable .aioRow {
  display: table-row;
}

.aioxTable > .aioBodyRow > .aioLabel,
.aioxTable > .aioBodyRow > .aioInputHolder,
.aioxTable > .aioBodyRow > .aioxButtonHolder {
  padding: 0 8px 0 8px;
}

.aioxTable.showBorders {
  border-right: 1px dotted burlywood;
  border-bottom: 1px dotted burlywood;
}

.aioxTable.showBorders > .aioBodyRow > .aioLabel,
.aioxTable.showBorders > .aioBodyRow > .aioInputHolder {
  border-left: 1px dotted burlywood;
}

.aioxTable.showBorders > .aioBodyRow > .aioLabel,
.aioxTable.showBorders > .aioBodyRow > .aioInputHolder,
.aioxTable.showBorders > .aioBodyRow > .aioxButtonHolder {
  border-top: 1px dotted burlywood;
}

div.aitAieHolder {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}

.aitAieHolder .aitAieHolderButton {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.5s ease-in;
}

.aitAieHolder:hover .aitAieHolderButton {
  opacity: 1;
  visibility: visible;
}

.aitBodyCell {
  vertical-align: top;
}

.aitBorderCell {
  border-bottom: 3px black solid !important;
  padding: 0;
  min-height: 1px;
}

.aitCell {
  height: fit-content;
  position: relative;
  min-width: 3rem;
}

.aitCell :global(.aiev3.has-replaced-text) {
  background-color: unset;
}

.aitCell .aioxButtonCell {
  z-index: 2;
}

.aitCell input {
  outline: 0;
}

.aitCell:has(:global(.aiev3.has-replaced-text)) {
  background-color: rgba(222, 184, 135, 0.25);
}

.aitCell.aitBodyCell {
  vertical-align: top;
}

.aitCell.aitBodyCell .aitOptionsButton {
  top: 0;
}

.aitCell.aitHeaderCell {
  vertical-align: bottom;
}

.aitCell.aitHeaderCell .aitOptionsButton {
  bottom: 0;
}

.aitCell.aitReadonlyCell {
  background-color: #d3d3d329;
  color: #0d0d0dc7;
  font-style: italic;
  opacity: 1;
}

.aitCell.aitRowHeaderCell {
  vertical-align: top;
}

.aitColumnButtons,
.aitRowButtons,
.aitRowGroupButtons {
  align-items: center;
  display: flex;
  min-height: 16px;
  opacity: 0.5;
  transition: opacity 0.3s ease-in-out;
  flex-shrink: 0;
}

.aitHolder {
  width: max-content;
  position: relative;
  display: block;
}

.aitOptionsButton {
  position: absolute;
  width: 16px;
  height: 16px;
  margin: 0 0 2px 2px;
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
  top: 0;
}

.aitOptionsButton.hidden {
  visibility: hidden;
}

.aitSpaceCell {
  padding: 0;
  height: 0.5rem;
}

.aitTable {
  border-collapse: collapse;
  margin: 2px;
}

.aitTableOptions {
  position: absolute;
  width: 16px;
  height: 16px;
  padding: 2px;
  left: 16px;
  top: 0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-gear' viewBox='0 0 16 16'%3E%3Cpath d='M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z'/%3E%3Cpath d='M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: cover;
}

.aitTableOptions.hidden {
  visibility: hidden;
}

.aiwBody {
  height: calc(100% - 43px);
}

.aiwBodyRow {
  display: flex;
  margin-bottom: 4px;
  line-height: 20px;
}

.aiwBodyRow :global(.aiev3.can-edit) :global(.aiev3-resize),
.aiwBodyRow .aioCommentHolder :global(.aiev3-resize) {
  border: 1px solid black;
  background-color: white;
  border-radius: 4px;
  margin-right: 0.5rem;
  padding: 0 4px 4px 4px;
}

.aiwBodyRow .aioCommentHolder {
  flex-grow: 1;
  min-width: 300px;
  min-height: 150px;
}

.aiwBodyRow .aioCommentHolder :global(.aiev3-resize) {
  height: calc(100% - 8px);
}

.aiwBodyRow .aioInput {
  border: 1px solid black;
  background-color: white;
  border-radius: 4px;
  padding-left: 8px;
  height: 28px;
  width: 166px;
}

.aiwBodyRow .aioInputHolder {
  flex-grow: 1;
  min-width: 300px;
}

.aiwBodyRow .aioLabel {
  min-width: 150px;
  min-height: 32px;
  vertical-align: middle;
}

.aiwBodyRow .aioSelect {
  border: 1px solid black;
  background-color: white;
  border-radius: 4px;
  padding-left: 4px;
  height: 28px;
  width: 184px;
}

.aiwHolder .aieOuter {
  border: 1px solid black;
  background-color: var(--bs-body-bg);
  border-radius: 2px;
  margin-right: 0.5rem;
  padding-bottom: 4px;
}

.aiwHolder .aioDropItemsHolder {
  z-index: 2002;
}

.aiwHolder,
.aioTip,
.aioDropItemsHolder {
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
}

.borderBlackSolid {
  border: 1px black solid;
  border-radius: 4px;
  padding: 2px;
}

.borderBottomBurlyWood {
  border-bottom: 1px burlywood solid;
}

.borderBurlyWoodDotted {
  border: 1px dotted burlywood;
  border-radius: 4px;
  padding: 2px;
}

.borderLeftBurlyWood {
  border-left: 1px burlywood solid;
}

.borderNone {
  border: none;
}

.borderRadiusBottomRight {
  border-bottom-right-radius: 4px;
}

.borderRadiusTopLeft {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.borderRadiusTopRight {
  border-top-right-radius: 4px;
}

.borderTopBottomBurlyWood {
  border-top: 1px burlywood solid;
  border-bottom: 1px burlywood solid;
}

.borderTopBurlyWood {
  border-top: 1px burlywood solid;
}

div.calcSize {
  width: calc(100% - 2px);
  height: calc(100% - 2px);
}

.colorRed {
  color: red;
}

.editorInput {
  width: 100%;
  height: 100%;
  border: none;
  overflow-x: visible;
  overflow-y: visible;
}

.flexCenter {
  display: flex;
  align-content: flex-center;
}

.flexColumn {
  display: flex;
  flex-direction: column;
}

.flexColumnGap2 {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.flexGrow1 {
  flex-grow: 1;
}

.flexRow {
  display: flex;
  flex-direction: row;
}

.flexRowCenter {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flexRowEnd {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.flexRowStart {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.fontItalic {
  font-style: italic;
}

.fullSize {
  width: 100%;
  height: 100%;
}

.margin2 {
  margin: 2px;
}

.margin6 {
  margin: 6px;
}

.marginBottom2 {
  margin-bottom: 2px;
}

.marginLeft25 {
  margin-left: 2.5rem;
}

.marginRight025 {
  margin-right: 0.25rem;
}

.marginTop2 {
  margin-top: 2px;
}

.marginTopBottom6 {
  margin-top: 6px;
  margin-bottom: 6px;
}

.maxHeight75vh {
  max-height: 75vh;
}

.overflowVisible {
  overflow-x: visible;
  overflow-y: visible;
}

.padding2 {
  padding: 2px;
}

.positionAbsolute {
  position: absolute;
}

.positionRelative {
  position: relative;
}

.replacementButtonArea {
  display: flex;
  justify-content: flex-end;
}

.replacementContainer {
  display: flex;
  flex-direction: column;
  gap: 2px;
  border: 1px dotted burlywood;
  padding: 2px;
  border-radius: 4px;
  margin: 2px;
}

.replacementRow {
  display: flex;
  flex-direction: row;
  align-content: center;
  margin-bottom: 2px;
}

.replacementRowIndented {
  display: flex;
  flex-direction: row;
  align-content: center;
  margin-left: 2.5rem;
  margin-top: 2px;
}

.width170 {
  width: 170px;
  min-width: 0;
}

.width5 {
  width: 5px;
  min-width: 5px;
}

tr:hover .aitColumnButtons,
tr:hover .aitRowButtons,
tr:hover .aitRowGroupButtons {
  opacity: 1;
}
